
import { Component, Vue } from 'vue-property-decorator';
import { iRealCertification } from '@/interface/real-certification';
import { getRealNameAuth, setRealNameAuth } from '@/api/real-certification';
import { toast } from '@/utils/common';
@Component
export default class extends Vue {
  model: iRealCertification = {
    real_name_auth: true,
    real_name_auth_can_skip: 1,
    real_name_auth_type: 0,
    real_name_pay_limit: 0,
  };
  defaulRadio = {
    true: 1,
    false: 0,
  };
  async handleSave() {
    const data = {
      real_name_auth: this.model.real_name_auth,
      real_name_auth_can_skip: this.model.real_name_auth_can_skip == 1 ? true : false,
      real_name_auth_type: this.model.real_name_auth_type == 1 ? 2 : 1,
      real_name_pay_limit: this.model.real_name_pay_limit == 1 ? true : false,
    };
    const res = await setRealNameAuth(data);
    if (res.code == 0) {
      toast('操作成功！');
      this.getRealCertification();
    }
  }
  async getRealCertification() {
    const res = await getRealNameAuth();
    if (res.code == 0) {
      const { real_name_auth, real_name_auth_can_skip, real_name_auth_type, real_name_pay_limit } = res.data;
      this.model.real_name_auth = real_name_auth;
      this.model.real_name_auth_can_skip = real_name_auth_can_skip ? 1 : 0;
      this.model.real_name_auth_type = real_name_auth_type == 2 ? 1 : 0;
      this.model.real_name_pay_limit = real_name_pay_limit ? 1 : 0;
    }
  }
  mounted() {
    this.getRealCertification();
  }
}
